import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { HomeComponent } from './pages/home/home.component';
import { LandingPageComponent } from './pages/landing-page/landing-page.component';
import { UserIntroComponent } from './pages/user-intro/user-intro.component';
import { LessonCategoriesComponent } from './pages/lesson-categories/lesson-categories.component';
import { MedicareComponent } from './pages/medicare/medicare.component'

const routes: Routes = [
    // { path: '', component: HomeComponent },
    { path: '', component: LandingPageComponent },
    { path: 'user-intro', component: UserIntroComponent },
    { path: 'lesson-categories', component: LessonCategoriesComponent },
    { path: 'plan-for-year', loadChildren: () => import('../app/pages/plan-for-year/plan-for-year.module').then(m => m.PlanForYearModule), data: { animation: 'PageTransition' } },
    { path: 'health-insurance-covers', loadChildren: () => import('../app/pages/health-insurance-covers/health-insurance-covers.module').then(m => m.HealthInsuranceCoversModule) },
    { path: 'my-information', loadChildren: () => import('../app/pages/my-information/my-information.module').then(m => m.MyInformationModule) },
    { path: 'my-family', loadChildren: () => import('../app/pages/my-family/my-family.module').then(m => m.MyFamilyModule) },
    { path: 'pre-retirement-costs', loadChildren: () => import('../app/pages/pre-retirement-costs/pre-retirement-costs.module').then(m => m.PreRetirementCostsModule)  },
    { path: 'retirement-costs', loadChildren: () => import('../app/pages/retirement-costs/retirement-costs.module').then(m => m.RetirementCostsModule)  },
    { path: 'hsa-information', loadChildren: () => import('../app/pages/hsa-information/hsa-information.module').then(m => m.HSAInformationModule)  },
    { path: 'hsa-investment', loadChildren: () => import('../app/pages/hsa-investment/hsa-investment.module').then(m => m.HSAInvestmentModule)  },
    { path: 'results', loadChildren: () => import('../app/pages/results/results.module').then(m => m.ResultsModule)  },
    { path: 'whats-next', loadChildren: () => import('../app/pages/whats-next/whats-next.module').then(m => m.WhatsNextModule)  },
    { path: 'medicare', component: MedicareComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'})],
    exports: [RouterModule],
})
export class AppRoutingModule { }
